// Singleton cache of the current user identity returned by /__tt/me.
// The shape is { email, name, image, roles }. Use `useMe()` in components
// or `getCachedMe()` for one-off lookups.
import { useEffect, useState } from 'react'
import { forceLogin } from './api.js'

let cached = null   // Promise<{email,name,image,roles} | null>

export function loadMe() {
  if (cached) return cached
  cached = fetch('/__tt/me', { credentials: 'include' })
    .then((r) => {
      // 401 → session cookie is missing or expired. The authenticated shell
      // (Layout) is the only caller of useMe(), so bounce straight to login.
      // (forceLogin() no-ops on public /survey/ pages.)
      if (r.status === 401) { forceLogin(); return null }
      return r.ok ? r.json() : null
    })
    .then((j) => (j && typeof j === 'object') ? j : null)
    .catch(() => null)
  return cached
}

/** React hook — returns the current user (or null while loading / unauthenticated). */
export function useMe() {
  const [me, setMe] = useState(null)
  useEffect(() => {
    let cancelled = false
    loadMe().then((m) => { if (!cancelled) setMe(m) })
    return () => { cancelled = true }
  }, [])
  return me
}

/** Case-insensitive "is admin" check across the user's `roles` array. */
export function isAdmin(me) {
  return Array.isArray(me?.roles) && me.roles.some((r) => /^admin$/i.test(String(r)))
}
